function isPaulHoodReferral(proAccountKey: string | undefined | null) {
  const paulHoodAccountKey: string | undefined =
    globalThis._APP_CONFIG?.paulhoodAccountKey;

  return (
    !!proAccountKey && !!paulHoodAccountKey?.split(',').includes(proAccountKey)
  );
}

export { isPaulHoodReferral };
